import { render, staticRenderFns } from "./PromotionProductUnit.vue?vue&type=template&id=1ef27370&"
import script from "./PromotionProductUnit.vue?vue&type=script&lang=ts&"
export * from "./PromotionProductUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports